import styled from "styled-components";

import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { StyledColumn, StyledFlex } from "./layout";
import { EditOutlined } from "../../materialUi/materialUi";
import { Spacer } from "../Spacer";
import { Avatar } from "../Avatar/Avatar";
import type { sizeOptionsInitialElement } from "../ElementInitial";

type AvatarSize = "M" | "L";

const nameTypographies: Record<AvatarSize, string> = {
  M: typographies["Header/H2"],
  L: typographies["Header/H1"],
};

const avatarSizes: Record<AvatarSize, sizeOptionsInitialElement> = {
  M: "ML",
  L: "L",
};

export interface ProfileRowProps {
  firstName: string;
  lastName: string;
  phone: string;
  onEdit: () => void;
  size?: AvatarSize;
}

export const ProfileRow = ({
  firstName,
  lastName,
  phone,
  onEdit,
  size = "M",
}: ProfileRowProps) => {
  const name = `${firstName} ${lastName}`;

  return (
    <StyledRow>
      <Avatar
        firstName={firstName}
        lastName={lastName}
        color="mint"
        size={avatarSizes[size]}
      />
      <Spacer x={0.75} />
      <StyledIdentity>
        <StyledName $size={size}>{name}</StyledName>
        <Spacer y={0.25} />
        <StyledPhone>{phone}</StyledPhone>
      </StyledIdentity>
      <Spacer x={0.75} />
      <StyledEditButton type="button" onClick={onEdit}>
        <EditOutlined />
      </StyledEditButton>
    </StyledRow>
  );
};

const StyledRow = styled(StyledFlex)`
  width: 100%;
  align-items: center;
`;

// Takes the remaining width so the edit button sits at the right edge.
const StyledIdentity = styled(StyledColumn)`
  flex: 1;
`;

const StyledName = styled.span<{ $size: AvatarSize }>`
  ${({ $size }) => nameTypographies[$size]}
  color: ${colors["colors/text/black"]};
`;

const StyledPhone = styled.span`
  ${typographies["Body/XS"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledEditButton = styled.button`
  /* Reset the native button chrome so spacing comes only from Spacer. */
  all: unset;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  fill: ${colors["colors/text/darkGrey"]};

  & svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;
